module.exports = __webpack_public_path__ + "img/10.c47f8c56.jpg";